<template>
    <div>
        <div class="left m-portlet" @click="handleChangeHeight(0)">
            <vue-scroll :ops="$ops" :style="{'height':550-changHeight+'px'}">
                <div class="m-portlet__body m-portlet__body--small-padding">
                    <el-form ref="form">
                        <el-row :gutter="20">
                            <!--学校选择-->
                            <el-col :span="12">
                                <el-form-item label="学校" prop="school">
                                    <el-input v-model="exam.school.name" disabled>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <!--考试名称-->
                            <el-col :span="12">
                                <el-form-item label="考试名称">
                                    <el-input
                                            type="text"
                                            placeholder="请输入考试名称"
                                            v-model="exam.name">
                                    </el-input>
                                </el-form-item>
                            </el-col>

                            <!--考试时间-->
                            <el-col :span="12">
                                <el-form-item label="考试时间">
                                    <el-date-picker
                                            v-model="exam.date"
                                            type="date"
                                            style="width: 100%"
                                            placeholder="选择日期">
                                    </el-date-picker>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item label="年级">
                                    <el-select v-model="exam.grade_id" filterable placeholder="请选择">
                                        <el-option
                                                v-for="item in filter.grades"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="班级">
                                    <el-select v-model="exam.schoolClass_id" filterable placeholder="请选择"
                                               @change="handleChangeSchoolClass">
                                        <el-option
                                                v-for="item in filter.schoolClasses"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item label="三总班级平均分">
                                    <el-input v-model="exam.mainClassAvgScore"
                                              placeholder="班级平均分"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="全科班级平均分">
                                    <el-input v-model="exam.sumClassAvgScore"
                                              placeholder="班级平均分"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item label="三总年级平均分">
                                    <el-input v-model="exam.mainGradeAvgScore"
                                              placeholder="班级平均分"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="全科年级平均分">
                                    <el-input v-model="exam.sumGradeAvgScore"
                                              placeholder="班级平均分"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item label="三总地区平均分">
                                    <el-input v-model="exam.mainAreaAvgScore"
                                              placeholder="班级平均分"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="全科地区平均分">
                                    <el-input v-model="exam.sumAreaAvgScore"
                                              placeholder="班级平均分"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </div>
            </vue-scroll>
        </div>
        <div class="right m-portlet" @click="handleChangeHeight(0)">
            <vue-scroll :ops="$ops">
                <div class="m-portlet__body m-portlet__body--small-padding"
                     :style="{'height':550-61.59-changHeight+'px'}">
                    <el-form>
                        <div style="height: 427px">
                            <el-row :gutter="20">
                                <el-form-item v-for="(subject, index) in exam.exam_subjects">
                                    <el-col :span="4">
                                        <el-form-item label="学科">
                                            <el-select v-model="subject.subject_id"
                                                       placeholder="请选择"
                                                       class="inputScore">
                                                <el-option
                                                        v-for="item in filter.subjects"
                                                        :key="item.id"
                                                        :label="item.name"
                                                        :value="item.id">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="4">
                                        <el-form-item label="总分">
                                            <el-input
                                                    v-model="subject.totalScore"
                                                    placeholder="学科总分"
                                                    class="inputScore"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="4">
                                        <el-form-item label="班级平均分">
                                            <el-input
                                                    v-model="subject.classAvgScore"
                                                    placeholder="年级平均分"
                                                    class="inputScore"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="4">
                                        <el-form-item label="年级平均分">
                                            <el-input v-model="subject.gradeAvgScore"
                                                      placeholder="年级平均分"
                                                      class="inputScore"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="4">
                                        <el-form-item label="区平均分">
                                            <el-input v-model="subject.areaAvgScore"
                                                      placeholder="区平均分"
                                                      class="inputScore"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="2" v-if="subject.id==0">
                                        <el-form-item label="操作">
                                            <el-button @click="handleRemoveSubject(index)">X
                                            </el-button>
                                        </el-form-item>
                                    </el-col>
                                </el-form-item>
                            </el-row>
                            <el-form-item>
                                <el-row :gutter="20">
                                    <el-col :span="11">
                                        <el-form-item>
                                            <el-button @click="handleAddSubject()">新增学科
                                            </el-button>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-form-item>
                        </div>
                    </el-form>
                </div>
            </vue-scroll>
            <div class="m-portlet__foot">
                <!--分页-->
                <div class="text-right">
                    <el-button v-if="powers.includes(35)" type="primary"
                               @click="handleUpdateSchoolExam()"
                               :loading="button_loading">修改
                    </el-button>
                </div>
            </div>
        </div>
        <div style="clear: both"></div>
        <div class="m-portlet" @click="handleChangeHeight(300)">
            <el-tabs type="border-card" v-model="activeName" @tab-click="changeExamSubject()">
                <el-tab-pane v-for="(exam_subject) in  exam.exam_subjects"
                             :label="filter.subjects[exam_subject.subject_id-1].name" :name="exam_subject.id.toString()"
                             :key="exam_subject.id">
                    <div class="tab-pane p-20 ">
                        <vue-scroll :ops="$ops" :style="{'height':150+changHeight+'px'}">
                            <table class="table" v-loading="studentLoading">
                                <thead>
                                <tr>
                                    <th>学生</th>
                                    <th>成绩</th>
                                    <th>班级排名</th>
                                    <th>年级排名</th>
                                    <th>区排名</th>
                                    <th>操作</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="item in studentExams">
                                    <td>{{item.student.name}}</td>
                                    <td>{{item.score}}</td>
                                    <td>{{item.classRank}}</td>
                                    <td>{{item.gradeRank}}</td>
                                    <td>{{item.areaRank}}</td>
                                    <td>
                                        <el-button type="primary"
                                                   @click="handleUpdateMainSchoolScore(item)">修改
                                        </el-button>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </vue-scroll>
                        <div class="text-center m-t-10">
                            <el-pagination
                                    @size-change="handleSizeChange"
                                    @current-change="handleCurrentChange"
                                    :current-page="currentPage"
                                    :page-sizes="[10, 20, 50, 100]"
                                    :page-size="10"
                                    layout="total, sizes, prev, pager, next, jumper"
                                    :total="total">
                            </el-pagination>
                        </div>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>


</template>

<script>
    export default {
        data() {
            return {
                path: "/exam/school/show",
                loading: 'true',
                button_loading: false,
                subject_ids: [],

                exam: {
                    id: '',
                    school_id: '',
                    school: {
                        name: ''
                    },
                    name: '',
                    data: '',
                    grade_id: '',
                    schoolClass_id: '',

                    mainGradeAvgScore: '',
                    sumGradeAvgScore: '',
                    mainAreaAvgScore: '',
                    sumAreaAvgScore: '',
                    exam_subjects: [],

                    schoolExam_schoolClass_id: 0,
                    mainClassAvgScore: '',
                    sumClassAvgScore: '',
                },

                filter: {
                    schools: [],
                    grades: [],
                    subjects: [],
                    organizationServices: [],
                    schoolClasses: []
                },
                studentExams: '',
                activeName: 0,
                total: 0,
                currentPage: 1,
                currentPageSize: 10,
                studentLoading: false,
                changHeight: 0,

                schoolScore: {
                    dialog_UpdateMainSchoolScore: {
                        button_loading: false,
                        student_schoolExam: {
                            name: '',
                            date: '',
                            school: {
                                name: ''
                            },
                            grade: {
                                name: ''
                            },
                            school_exams: {
                                name: '',
                                date: '',
                            },
                            schoolExam_schoolClass_id: '',
                            mainScore: '',
                            sumScore: '',
                            mainClassRank: '',
                            mainGradeRank: '',
                            mainAreaRank: '',
                            sumClassRank: '',
                            sumGradeRank: '',
                            sumAreaRank: '',
                            schoolScores: {
                                school_exam_subject: {
                                    subject: {
                                        name: ''
                                    },
                                },
                                score: '',
                                classRank: '',
                                gradeRank: '',
                                areaRank: '',
                            },
                            school_exam_school_class: {
                                schoolClass_id: 0
                            },
                        },
                        schoolClasses: {
                            id: '',
                            name: '',
                        },
                    },
                },
                initInformation: {
                    schoolClasses: ''
                },
            }
        },
        created() {

            this.handleCreate();
            this.handleInit();
            this.handleShowSchoolExam();
        },
        computed: {
            powers() {
                return this.$store.state.config.powers;
            },
            clientHeight() {
                return this.$store.state.config.clientHeight
            },
        },
        methods: {
            handleChangeHeight(changHeight) {
                this.changHeight = changHeight;
            },
            handleCreate() {
                this.$wApi.addListen(this.path, this.handleData);
            },
            handleInit() {
                this.$wApi.send(this.path, 'init', {});
            },
            handleShowSchoolExam() {
                this.$wApi.send(this.path, 'show', {
                    'schoolExam_id': this.$route.params.id,
                });
            },
            handleData(event, data, status) {
                switch (event) {
                    case 'subscribe':
                        break;
                    case 'init':
                        this.filter.schools = data.schools;
                        this.filter.exams = data.exams;
                        this.filter.grades = data.grades;
                        this.filter.subjects = data.subjects;
                        this.filter.schoolClasses = data.schoolClasses;
                        this.initInformation.schoolClasses = data.schoolClasses;
                        this.loading = false;
                        break;
                    case 'show':
                        this.exam = data.schoolExam;
                        this.exam.schoolExam_schoolClass_id = 0;
                        this.exam.schoolClass_id = '';
                        this.exam.mainClassAvgScore = '';
                        this.exam.sumClassAvgScore = '';
                        this.exam.exam_subjects.forEach((item) => {
                            item.schoolExam_subject_schoolClass_id = 0;
                            item.classAvgScore = ''
                        });
                        this.activeName=this.exam.exam_subjects[0].id.toString()
                        if(this.activeName){
                            this.changeExamSubject();
                        }
                        this.loading = false;
                        break;
                    case 'update_schoolExam':
                        if (status == 'success') {
                            this.$message({
                                message: '修改学校考试成功',
                                type: 'success'
                            });
                        }
                        this.button_loading = false;
                        break;
                    case 'update_schoolExam_error':
                        this.button_loading = false;
                        break;
                    case 'choose_studentScore':
                        this.studentExams = data.studentExams;
                        this.total = data.total;
                        this.studentLoading = false;
                        break;
                    case 'change_schoolClass':
                        if (data.schoolExam_schoolClass !== null) {
                            this.exam.schoolExam_schoolClass_id = data.schoolExam_schoolClass.id;
                            this.exam.mainClassAvgScore = data.schoolExam_schoolClass.mainClassAvgScore;
                            this.exam.sumClassAvgScore = data.schoolExam_schoolClass.sumClassAvgScore;
                        } else {
                            this.exam.schoolExam_schoolClass_id = 0;
                            this.exam.mainClassAvgScore = '';
                            this.exam.sumClassAvgScore = '';
                        }

                        this.exam.exam_subjects.forEach((item) => {
                            item.schoolExam_subject_schoolClass_id = 0;
                            item.classAvgScore = ''
                        });
                        data.schoolExam_subject_schoolClasses.forEach((item) => {
                            this.exam.exam_subjects.forEach((item1) => {
                                if (item1.id === item.schoolExam_subject_id) {
                                    item1.schoolExam_subject_schoolClass_id = item.id;
                                    item1.classAvgScore = item.classAvgScore
                                }
                            });
                        });
                        this.loading = false;
                        break;
                    case 'showStudentExam':
                        this.schoolScore.dialog_UpdateMainSchoolScore.student_schoolExam = data.showStudentExam.student_schoolExam;
                        if (this.schoolScore.dialog_UpdateMainSchoolScore.student_schoolExam.school_exam_school_class == null) {
                            this.schoolScore.dialog_UpdateMainSchoolScore.student_schoolExam.school_exam_school_class = {
                                id: 0,
                                schoolClass_id: '',
                                mainClassAvgScore: '',
                                sumClassAvgScore: '',
                            }
                        }
                        this.schoolScore.dialog_UpdateMainSchoolScore.loading = false;
                        break;
                    case 'updateSchoolExam':
                        if (status == 'success') {
                            this.$message({
                                message: '修改成功',
                                type: 'success'
                            });
                        }
                        this.$Win.closeModal();
                        data.student_schoolExam.studentSchoolScores.forEach((item) => {
                            Object.keys(this.studentExams).forEach((index) => {
                                if (index == item.id) {
                                    this.studentExams[index]['areaRank'] = item.areaRank;
                                    this.studentExams[index]['classRank'] = item.classRank;
                                    this.studentExams[index]['gradeRank'] = item.gradeRank;
                                    this.studentExams[index]['score'] = item.score;
                                }
                            });
                        });
                        this.schoolScore.dialog_UpdateMainSchoolScore.button_loading = false;
                        break;
                    case 'updateSchoolExamError':
                        this.schoolScore.dialog_UpdateMainSchoolScore.button_loading = false;
                        break;
                }
            },
            handleRemoveSubject(index) {
                this.exam.exam_subjects.splice(index, 1)
            },
            handleAddSubject() {
                this.exam.exam_subjects.push({
                    id: 0,
                    subject_id: 1,
                    classAvgScore: '',
                    gradeAvgScore: '',
                    areaAvgScore: '',
                    schoolClass_id: '',
                    schoolExam_subject_schoolClass: {
                        id: 0,
                        schoolExam_subject_id: '',
                        schoolClass_id: '',
                        classAvgScore: '',
                    },
                    schoolExam_subject_schoolClass_id: this.exam.exam_subjects[0].schoolExam_subject_schoolClass_id,
                });
            },
            handleSearchSchool(query) {
                this.$wApi.send(this.path, 'search', {
                    'type': 'schoolKeyName',
                    'schoolKeyName': query,
                });
            },
            //修改学校考试
            handleUpdateSchoolExam() {
                this.button_loading = true;
                this.$confirm('确认修改?', '提示', {
                    StartReturn: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.exam.date = this.$moment(this.exam.date).format('YYYY-MM-DD');
                    this.$wApi.send(this.path, 'update_schoolExam', {
                        'schoolExam_id': this.$route.params.id,
                        'exam': this.exam
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                    this.button_loading = false;
                });

            },
            //查找学生成绩
            changeExamSubject() {
                this.total = 0;
                this.currentPage = 1;
                this.currentPageSize = 10;
                this.chooseStudentScore();
            },
            chooseStudentScore() {
                this.studentLoading = true;
                this.$wApi.send(this.path, 'choose_studentScore', {
                    'exam_subject_id': this.activeName,
                    'currentPage': this.currentPage,
                    'currentPageSize': this.currentPageSize
                });
            },
            handleChangeSchoolClass(event) {
                this.$forceUpdate();
                this.loading = true;
                this.$wApi.send(this.path, 'change_schoolClass', {
                    'schoolExam_id': this.$route.params.id,
                    'schoolClass_id': event
                });
            },
            handleUpdateMainSchoolScore(item) {
                this.$Win.openModal('Dialog_UpdateMainSchoolScore', 1224, 750, '修改学校考试', {
                    'id': item.student_schoolExam_id,
                    'student_id': item.student_id,
                });
            },
            handleSizeChange(val) {
                this.currentPageSize = val;
                this.chooseStudentScore(this.currentPage, this.currentPageSize)
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.chooseStudentScore(this.currentPage, this.currentPageSize)
            }
        },
    }
</script>

<style scoped>
    .inputScore {
        width: 100px;
    }

    .left {
        float: left;
        width: 450px;
    }

    .right {
        margin-left: 470px;
    }
</style>
